import styled from 'styled-components';
import { Div } from 'styles';

export const TableHead = styled(Div)`
  padding: 16px 30px;
  border-top: 1px solid ${({ theme }) => theme.gray}4c;
  color: ${({ theme }) => theme.white};
`;

export const TableRow = styled(Div)`
  color: ${({ theme }) => theme.white};

  background: radial-gradient(
      158.48% 294.91% at 50% 320.96%,
      rgba(0, 204, 240, 0.98) 0%,
      rgba(0, 208, 240, 0) 100%
    ),
    linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1));

  border: 1px solid ${({ theme }) => theme.gray}4c;
  margin-bottom: 10px;
  padding: 20px 30px;
  cursor: pointer;
`;

export const StatusPill = styled(Div)<{ $color: string; $textColor: string }>`
  width: 85px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $color }) => $color};
  color: ${({ $textColor }) => $textColor};
  font-size: 12px;
  border-radius: 100px;
  text-transform: capitalize;
`;
